// @ts-nocheck
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import notification from 'antd/lib/notification';
import { Panel } from './../../components/layout';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import Header from '../../components/layout/Header';
import { getPathWithHistoryParams, navigate } from '../../lib/helpers';
import { driverApi } from './../../lib/api';
import { notificationLoading } from '../../components/Notifications';
import InnerForm from './components/InnerForm';
const StyledPanel = styled(Panel).withConfig({
  displayName: "DriverForm__StyledPanel",
  componentId: "sc-wik2c5-0"
})(["padding-top:0;"]);
class DriverForm extends Component {
  state = {};
  async componentDidMount() {
    const {
      driverId
    } = this.props;
    try {
      if (driverId) {
        const driver = await driverApi.fetchDriver(driverId);
        this.setState({
          driver
        });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
      await navigate('/admin/drivers', true);
    }
  }
  onSubmit = async driver => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      let data;
      if (driver.id) {
        data = await driverApi.updateDriver(driver);
      } else {
        data = await driverApi.addDriver(driver);
      }
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      await navigate(`/admin/drivers/${data.id}`, true);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };
  render() {
    const {
      employeeBranchOrgUnitId
    } = this.props;
    const {
      driver
    } = this.state;
    return <>
        <Header left={<Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to={getPathWithHistoryParams('/admin/drivers')}>
                Водители
              </Crumb>
              {driver ? <Crumb to={`/admin/drivers/${driver.id}`}>
                  Водитель №{driver.id}
                </Crumb> : <Crumb to="/admin/drivers/new">Новый водитель</Crumb>}
            </Breadcrumbs>} />
        <StyledPanel>
          <h1>{driver ? `Водитель №${driver.id}` : 'Новый водитель'}</h1>
        </StyledPanel>
        <InnerForm onSubmit={this.onSubmit} onCancel={() => navigate('/admin/drivers', true)} driver={driver} employeeBranchOrgUnitId={employeeBranchOrgUnitId} />
      </>;
  }
}
export default connect((state, ownProps) => ({
  driverId: parseInt(ownProps.driverId, 10),
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
}))(DriverForm);
